import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { SettingsPage } from '~/pages/settings';
import { profileRoute } from '~/router/app/settings/profile';
import { teamsRoute } from '~/router/app/settings/teams';
import { accessProfileRoutes } from '~/router/app/settings/access-profiles';
import { agencyRoute } from '~/router/app/settings/agency';
import { designRoute } from '~/router/app/settings/design';
import { analyticsRoute } from '~/router/app/settings/analytics';
import { usageRoute } from '~/router/app/settings/usage';
import { limitsRoute } from '~/router/app/settings/limits';
import { subscriptionRoute } from '~/router/app/settings/subscription';
import { integrationsRoute } from '~/router/app/settings/integrations';
import { voiceRoutes } from '~/router/app/settings/voice';
import { mailboxSettingsRoute } from '~/router/app/settings/mailbox';
import { memoryRoute } from '~/router/app/settings/memory';
import { emailRoute } from '~/router/app/settings/email';

export const settingsRoute: RouteObject = {
  id: 'settings',
  path: 'settings',
  element: <SettingsPage />,
  children: [
    {
      index: true,
      element: <Navigate to="profile" replace />
    },
    profileRoute,
    teamsRoute,
    ...accessProfileRoutes,
    agencyRoute,
    designRoute,
    analyticsRoute,
    usageRoute,
    limitsRoute,
    subscriptionRoute,
    integrationsRoute,
    ...voiceRoutes,
    mailboxSettingsRoute,
    memoryRoute,
    emailRoute
  ]
};
